import { useMutation, useQueryClient } from "@tanstack/react-query";
import { clearBettingSelectionsSuspensions } from "@/api/bettingSelections";
import { BettingSelectionsQueryKeys } from "@/tanstackQuery/queries/bettingSelections";
import type {
  ClearBettingSelectionSuspensionsParams,
  BettingSelectionSuspensionsEditorResponse,
} from "@/types/ApiResponses/BettingSelection";

export const useClearBettingSelectionsSuspensions = (
  bettingMarketId?: number,
  targetUsername?: string
) => {
  const queryClient = useQueryClient();
  const queryKey = [BettingSelectionsQueryKeys.BettingSelectionsSuspensions, bettingMarketId, targetUsername];

  return useMutation({
    mutationFn: (params: ClearBettingSelectionSuspensionsParams) =>
      clearBettingSelectionsSuspensions(params),
    onMutate: async () => {
      await queryClient.cancelQueries({ queryKey, exact: true });

      const previousData =
        queryClient.getQueryData<BettingSelectionSuspensionsEditorResponse>(queryKey);

      if (previousData) {
        queryClient.setQueryData<BettingSelectionSuspensionsEditorResponse>(queryKey, {
          ...previousData,
          suspensions: {},
        });
      }

      return { previousData };
    },
    onError: (_err, _variable, context) => {
      if (context?.previousData) {
        queryClient.setQueryData(queryKey, context.previousData);
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey, exact: true });
    },
  });
};
